// <- TaskManagment.js
import React, { useState, Fragment } from "react";
import { Button, ListGroup, ListGroupItem, Input } from "reactstrap";
import moment from "moment";
import "../../../style/employeeTask.css";
import addTaskIcon from '../../../img/addtask.png';
import markLeaveIcon from '../../../img/markleave.png';
import unlockRequestIcon from '../../../img/unlockrequest.jpg';
import clearfilterIcon from '../../../img/clearfilter.jpg';
import calendarIcon from '../../../img/calendar.png';
import tableswitchIcon from '../../../img/tableswitch.png';
import taskIcon from '../../../img/Taskwise.png';
import weekIcon from '../../../img/Weekwise.png';
import dayIcon from '../../../img/Daywise.jpeg';
// removed unused OverlayTrigger and useHistory imports to satisfy linter

const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
const ListTask = React.memo(
  ({
    handleAddEditTaskForm,
    handleAddEditLeaveForm,
    handleSelectedTask,
    handleSelectedDailyTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handleClearFilter,
    filteredtaskList,
    isclicked,
    handleExcelImport,
    handlesearch,
    fromDate,
    toDate,
    currentWeekStart,
    currentWeekEnd,
    lastWeekStart,
    lastWeekEnd,
    unlockReqList,
    allowedDatesN,
    searchTask,
    handleCheckboxChange,
    selectedTask,
    expandedIndex,
    expandedTaskId,
    listViewMode,
    setListViewMode
  }) => {

    const [activeTask, setActiveTask] = useState(0);
    // track which date groups are expanded in Date View
      const [expandedDates, setExpandedDates] = useState({});
    // track expanded rows locally so chevron reliably toggles expansion
    const [expandedRows, setExpandedRows] = useState({});
 const [searchValue, setSearchValue] = useState("");

    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedDailyTask(task, i);
      },
      [handleSelectedDailyTask]
    );

    const handleOnclickAddEditTask = React.useCallback(
      (task) => {
        handleAddEditTaskForm(task);
      },
      [handleAddEditTaskForm]
    );

    const handleOnclickAddEditLeave = React.useCallback(
      (task) => {
        handleAddEditLeaveForm(task);
      },
      [handleAddEditLeaveForm]
    );
    const DelTask = React.useCallback(
      (delId, tasks) => {
        handleDelTask(delId, tasks);
      }, [empTask]);

    const today = new Date();

    // ✅ Get the first day of the current week (Sunday)
    const firstDay = new Date(
      today.setDate(today.getDate() - today.getDay()),
    );

    // ✅ Get the last day of the current week (Saturday)
    const lastDay = new Date(
      today.setDate(today.getDate() - today.getDay() + 6),
    );
    // tooltip removed (was unused) to satisfy linter
const handleRedirectToMyLeaves = () => {
  const projectId = taskProjectInfo?.projectId || 0; // Replace with your actual ProjectId source
    localStorage.setItem("projectId", projectId);
  window.open('/ApplyMyLeaves', '_blank');
};


    function getDatesInRange(startDate, endDate) {
      const date = new Date(startDate);
      const enddate = new Date(endDate)
      const dates = [];

      while (date <= enddate) {
        dates.push(moment(new Date(date)).format("YYYY-MM-DD"));
        date.setDate(date.getDate() + 1);
      }

      return dates;
    }
    let datearray = [];
    if (unlockReqList !== null && Array.isArray(unlockReqList) && unlockReqList.length !== 0 && unlockReqList[0] !== '') {
      let fromDate = unlockReqList[0].fromDate;
      var daterange = [];
      unlockReqList.forEach(function (unlock) {
        daterange = getDatesInRange(moment(unlock.fromDate).format("YYYY-MM-DD"), moment(unlock.toDate).format("YYYY-MM-DD"));
        daterange.forEach(function (range) {
          datearray.push(range);
        });
      });
    }

    // if(moment("2024-02-13").format("YYYY-MM-DD") > moment(firstDay).format("YYYY-MM-DD") && moment("2024-02-13").format("YYYY-MM-DD") < moment(lastDay).format("YYYY-MM-DD")){
    //   alert("1");
    // }
    // else
    // {
    //   alert("2");
    // }
    return (
      <Fragment>
        <div className="fixed-header" style={{ height: "120px", width: "100%", gap: "5px", paddingTop: "20px", display: "flex", justifyContent: "center" }}>
          <div className="fixed-header" style={{
            height: "auto",
            width: "fit-content",          // makes the box fit its content
            padding: "15px",
            border: "1px solid #ccc",      // light border
            borderRadius: "10px",          // rounded corners
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // optional shadow
            backgroundColor: "#fff",
            display: "flex",      // white background
            justifyContent: "center",  // centers horizontally
            alignItems: "center",
          }}>
            <div className="d-flex align-items-center" style={{
              gap: "10px",
              flexWrap: "wrap",
              display: "flex",
              justifyContent: "center",   // center items inside the box
            }}>

              {(loginUser !== null &&
                loginUser.RoleName === "Admin") ? ((<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={() => handleOnclickAddEditTask("add")}
                >
                  <img src={addTaskIcon} alt="Add Task" title="Add Task" style={{ width: "32px", height: "32px" }} />

                </Button>)) : (
                (taskProjectInfo?.status === false) ? (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={() => handleOnclickAddEditTask("add")} disabled={true}
                >
                  <img src={addTaskIcon} alt="Add Task" title="Add Task" style={{ width: "32px", height: "32px" }} />
                </Button>) : (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={() => handleOnclickAddEditTask("add")}
                >
                  <img src={addTaskIcon} alt="Add Task" title="Add Task" style={{ width: "32px", height: "32px" }} />
                </Button>))}

              &nbsp;
              {(loginUser !== null &&
                loginUser.RoleName === "Admin") ? null : ((taskProjectInfo.status === false) ? (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={handleUnlockRequestForm}
                  disabled={true}
                >
                  <img src={unlockRequestIcon} alt="Unlock Request" title="Unlock Request" style={{ width: "32px", height: "32px" }} />
                </Button>) : (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={handleUnlockRequestForm}
                >
                  <img src={unlockRequestIcon} alt="Unlock Request" title="Unlock Request" style={{ width: "32px", height: "32px" }} />
                </Button>))}
              &nbsp;

              {(loginUser !== null &&
                loginUser.RoleName === "Admin") ? ((<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={() => handleOnclickAddEditLeave("add")}
                >
                  <img src={markLeaveIcon} alt="Mark Leave" title="Mark Leave" style={{ width: "32px", height: "32px" }} />
                </Button>)) : (
                (taskProjectInfo.status === false) ? (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={handleRedirectToMyLeaves} disabled={true}
                >
                  <img src={markLeaveIcon} alt="Mark Leave" title="Mark Leave" style={{ width: "32px", height: "32px" }} />
                </Button>) : (<Button
                  size="sm"
                  outline
                  className="secondary"
                  onClick={handleRedirectToMyLeaves}
                >
                  <img src={markLeaveIcon} alt="Mark Leave" title="Mark Leave" style={{ gap: "10px", width: "32px", height: "32px" }} />
                </Button>))}
              &nbsp;
              {/* <Button size="sm" outline className="secondary" onClick={handleToggleAllTaskCalendar}>
                <img src={tableswitchIcon} alt="Calendar" title="Switch to all task" style={{ width: "32px", height: "32px" }} />
              </Button> */}
              &nbsp;
              
            </div>
          </div>
          <div className="fixed-header" style={{
            height: "auto",
            width: "fit-content",          // makes the box fit its content
            padding: "15px",
            border: "1px solid #ccc",      // light border
            borderRadius: "10px",          // rounded corners
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // optional shadow
            backgroundColor: "#fff",
            display: "flex",      // white background
            justifyContent: "center",  // centers horizontally
            alignItems: "center",
          }}>
            <div className="d-flex align-items-center" style={{
              gap: "10px",
              flexWrap: "wrap",
              display: "flex",
              justifyContent: "center",   // center items inside the box
            }}>
<div style={{ display: 'flex', gap: '20px' }}>
  <Button size="sm"
                  outline
                  className="secondary"  style={{
          border: "1px solid #000",
          fontWeight: "900",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          backgroundColor: "#fff",
        }} onClick={() => setListViewMode && setListViewMode('task')}>
<img src={taskIcon} alt="Tasks" title="Task Wise View" width={32} height={32} />
  </Button>
  <Button  size="sm"
                  outline
                  className="secondary"  style={{
          border: "1px solid #000",
          fontWeight: "900",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          backgroundColor: "#fff",
        }} onClick={() => setListViewMode && setListViewMode('date')}>
<img src={dayIcon} alt="Day" title="Day Wise View" width={32} height={32}  />
</Button>
<Button  size="sm"
                  outline
                  className="secondary"  style={{
          border: "1px solid #000",
          fontWeight: "900",
          boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
          backgroundColor: "#fff",
        }} onClick={handleToggleAllTaskCalendar}>
<img src={weekIcon} alt="Week" title="Week Wise View" width={32} height={32} />
</Button>

      
      <label className="d-flex align-items-center mb-0">
                <input
                  type="checkbox"
                  //checked={isclicked === 0}
                  onChange={(e) => handleCheckboxChange(e.target.checked)}
                  style={{
                    transform: 'scale(1.5)',  // Increase size by 1.5 times
                    marginRight: '5px',
                    gap: '10px'
                  }}
                />
                All Projects
              </label>
    </div>
            </div>
            </div>
        </div>


        <br />

        <div style={{ display: "flex", gap: "12px", flexWrap: "nowrap", alignItems: "center", overflowX: "auto", padding: "8px 0", }}>
          <Input
            type="text"
            //className="d-inline"
            placeholder="Search Task...."
            value={searchValue}
  onChange={(e) => {
    const val = e.target.value;
    setSearchValue(val);
    searchTask(val);
  }}
            style={{
              flexShrink: 1,       // can shrink but not too small
              flexGrow: 1,         // can grow to fill available space
              minWidth: "150px",   // prevent too small on tiny screens
              maxWidth: "600px",
              padding: "8px",
              whiteSpace: "nowrap",
            }}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
              flexShrink: 0,        // do NOT shrink, keep full size
              gap: "6px",
              fontSize: "14px",
              minWidth: "220px",
            }}
          >
            {/* <div style={{ display: 'flex', gap: 6 }}>
              <button type="button" className={`btn ${listViewMode === 'task' ? 'btn-success' : 'btn-outline-secondary'}`} style={listViewMode === 'task' ? { backgroundColor: '#30484d', color: 'white', borderColor: '#30484d' } : {}} onClick={() => setListViewMode && setListViewMode('task')}>Task View</button>
              <button type="button" className={`btn ${listViewMode === 'date' ? 'btn-success' : 'btn-outline-secondary'}`} style={listViewMode === 'date' ? { backgroundColor: '#30484d', color: 'white', borderColor: '#30484d' } : {}} onClick={() => setListViewMode && setListViewMode('date')}>Date View</button>
            </div> */}

            {isclicked == 1 ? (<div style={{ display: "flex", alignItems: "center" }}>
              <h6>Your task for the dates </h6>&nbsp;&nbsp;
              <h6>From :</h6>&nbsp;

              <h6 style={{ color: 'blue' }}>{moment(fromDate).format("DD-MM-YYYY")}</h6> &nbsp;&nbsp;

              <h6>To :</h6>&nbsp;
              <h6 style={{ color: 'blue' }}>{moment(toDate).format("DD-MM-YYYY")}</h6>
            </div>) : (

              <div style={{ display: "flex", alignItems: "center" }}>
                <h6>Your task for the dates</h6> &nbsp;&nbsp;
                <h6>From :</h6>&nbsp;

                <h6 style={{ color: 'blue' }}>{moment(lastWeekStart).format("DD-MM-YYYY")}</h6> &nbsp;&nbsp;

                <h6>To :</h6>&nbsp;
                <h6 style={{ color: 'blue' }}>{moment(currentWeekEnd).format("DD-MM-YYYY")}</h6>
              </div>)}

          </div>


          <Button size="sm" outline className="secondary" onClick={handleOpenCalendar} style={{ flexShrink: 0 }}>
            <img src={calendarIcon} alt="Calendar" title="Filter with date" style={{ width: "32px", height: "32px" }} />
          </Button>


       <Button
  size="sm"
  outline
  className="secondary"
  onClick={() => {
    handleClearFilter();
    setSearchValue("");        // 🔹 Reset input box
    searchTask("");            // 🔹 Clear search filter results too
  }}
  style={{ flexShrink: 0 }}
>
  <img
    src={clearfilterIcon}
    alt="Clear Filter"
    title="Clear Filter"
    style={{ width: "32px", height: "32px" }}
  />
</Button>



        </div>

        <div style={{ overflow: 'auto', width: '100%', maxHeight: '650px' }}>
          {/* Date View */}
          {listViewMode === 'date' ? (
            (() => {

              // group tasks by each statusDate (so Date View shows only entries for that date)
           const start = moment(fromDate == null ? lastWeekStart :fromDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).startOf('day');
const end = moment(toDate == null ? currentWeekEnd :toDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).endOf('day');

// Group tasks by date safely
const groups = (empTask || []).reduce((acc, t) => {
  if (!t) return acc;

  // Normalize all date sources
  const statuses = Array.isArray(t.employeeTimeSheetStatuses) && t.employeeTimeSheetStatuses.length > 0
    ? t.employeeTimeSheetStatuses
    : [{ statusDate: t.workDate, hoursLogged: t.totalHoursLogged ?? t.hoursSpent, dutyType: t.dutyType, description: t.description }];

  statuses.forEach(s => {
    const raw = s.statusDate || s.workDate || t.workDate;
    const date = moment(raw, ['YYYY-MM-DD', 'DD-MM-YYYY', moment.ISO_8601]);
    if (!date.isValid()) return;

    if (date.isBetween(start, end, 'day', '[]')) {
      const dateKey = date.format('YYYY-MM-DD');
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push({ task: t, status: s });
    }
  });

  return acc;
}, {});

              const sortedDates = Object.keys(groups).sort((a, b) => new Date(b) - new Date(a));

              return (
                <div>
                  {sortedDates.length === 0 && <div className="task-label">No task added</div>}
                  {sortedDates.map((dateKey) => {
                    const entries = groups[dateKey];
                    const totalHours = entries.reduce((s, it) => s + (parseFloat(it.status?.hoursLogged || it.task?.totalHoursLogged || it.task?.hoursSpent || 0) || 0), 0);
                    // group entries by task so each task header appears once
                   const tasksById = entries.reduce((acc, it) => {
  const t = it.task || {};

  // 🧩 create a guaranteed unique key per task entry
  const uniqueKey =
    (t.issueID ? `issue_${t.issueID}` : '') +
    (t.employeeTimeSheetId ? `_ts_${t.employeeTimeSheetId}` : '') +
    `_${t.issueTitle?.trim().toLowerCase() ?? ''}_${t.projectID ?? t.projectId ?? ''}`;

  if (!acc[uniqueKey]) {
    acc[uniqueKey] = { task: t, statuses: [] };
  }
  acc[uniqueKey].statuses.push(it.status);

  return acc;
}, {});


                    return (
                      <div key={dateKey} className="card mb-3">
                        <div
  className="card-header d-flex justify-content-between align-items-center"
  style={{
    backgroundColor: "#fff",
    borderBottom: "1px solid #f2f2f2",
    padding: "12px 18px",
    cursor: "pointer",
  }}
  onClick={() =>
    setExpandedDates((prev) => ({ ...prev, [dateKey]: !prev[dateKey] }))
  }
>
  {/* === LEFT SIDE === */}
  <div className="d-flex align-items-center" >
    <i
      className={`fas ${
        expandedDates[dateKey] ? "fa-chevron-down" : "fa-chevron-right"
      }`}
      style={{
        marginRight: "10px",
        color: "#555",
        fontSize: "14px",
      }}
    ></i>
    <strong
      style={{
        fontSize: "15px",
        color: "#333",
        fontWeight: "600",
      }}
    >
      {moment(dateKey).format("ddd, MMM DD, YYYY")}
    </strong>
    <span
      className="ml-2"
      style={{
        backgroundColor: "#e0f7f4",
        color: "#009688",
        borderRadius: "6px",
        fontSize: "12px",
        padding: "3px 8px",
        fontWeight: "500",
        marginLeft: "8px",
      }}
    >
      {Object.keys(tasksById).length} Task
      {Object.keys(tasksById).length > 1 ? "s" : ""}
    </span>
  </div>

  {/* === RIGHT SIDE === */}
  <div className="d-flex align-items-center" style={{gap:'15px'}}>
    <small
      style={{
        color: "#555",
        fontSize: "12px",
      }}
    >
      Total Hours: &nbsp;
      <strong
        style={{
          color: "#009688",
          fontWeight: "600",
          fontSize: "14px",
        }}
      >
        {totalHours.toFixed(1)}h
      </strong>
    </small>

    {/* Edit Icon */}
    <span
      title="Edit Day"
      onClick={(e) => {
        e.stopPropagation();
        if (entries && entries.length > 0) {
          const synthStatuses = entries.map((en) => {
            let s = en.status || {};
            if (
              Array.isArray(en.employeeTimeSheetStatuses) &&
              en.employeeTimeSheetStatuses.length > 0
            ) {
              s = en.employeeTimeSheetStatuses[0];
            }
            const t = en.task || {};
           const hoursSpent =
  s.hoursLogged ??
  s.hoursSpent ??
  t.totalHoursLogged ??
  t.hoursSpent ??
  0;

const hoursBillable =
  s.hoursBillable ??
  s.hoursLoggedBillable ??
  t.hoursBillable ??
  t.billableHours ??
  0;
            const rawDate =
              s.statusDate || s.workDate || en.workDate || dateKey;
            const parsed = moment(rawDate, ["YYYY-MM-DD", moment.ISO_8601], true);
            const safeDate = parsed.isValid()
              ? parsed.format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD");

          return {
  projectID: t.projectID ?? t.projectId ?? en.projectID ?? null,
  projectName: t.projectName ?? t.name ?? en.projectName ?? "",
  issueTitle: t.issueTitle ?? en.issueTitle ?? "",
  workingHours: hoursSpent,
  hoursSpent,
  hoursBillable,
  dutyTypeId: s.dutyTypeId ?? "",
  status: s.status ?? en.status?.status ?? "",
  statusDate: safeDate,
  timeSheetStatus: s.timeSheetStatus ?? s.status ?? "",
  timesheetStatusId: s.timesheetStatusId ?? 0,
  description: s.description ?? "",
  employeeTimeSheetId: en.task.employeeTimeSheetId ?? null,
};
          });

          const syntheticTask = {
            ...entries[0].task,
            employeeTimeSheetStatuses: synthStatuses,
            workDate: dateKey,
          };

          handleSelectedDailyTask?.(syntheticTask, 0);
          handleAddEditTaskForm?.("edit", syntheticTask);
        }
      }}
     style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "black",
          fontSize: "16px",
          padding: 0,
        }}
    >
      <i className="fa fa-edit"></i>
    </span>
  </div>
</div>

                        {expandedDates[dateKey] && (
                       <div className="card-body">
  {Object.values(tasksById).map((entry, idx) => (
    <div key={idx} >
      

      {/* loop through all statuses for this task */}
      {(entry.statuses || []).map((statusItem, i) => {
        const dutyRaw = statusItem.dutyType || '';
        const dutyShort =
          /work\s*from\s*home/i.test(dutyRaw)
            ? 'WFH'
            : /work\s*from\s*office/i.test(dutyRaw)
            ? 'WFO'
            : dutyRaw || '-';

        const dutyClass =
          dutyShort === 'WFH'
            ? 'badge-wfh'
            : dutyShort === 'WFO'
            ? 'badge-wfo'
            : 'badge-default';

        const statusVal =
          typeof statusItem.status === 'number'
            ? statusItem.status === 3
              ? 'Completed'
              : statusItem.status === 2
              ? 'In Progress'
              : 'New'
            : statusItem.status || 'New';

        const statusClass =
          statusVal === 'Completed'
            ? 'badge-completed'
            : statusVal === 'In Progress'
            ? 'badge-progress'
            : 'badge-pending';

        return (
  <div key={i} className="time-entry-subcard mt-3">

     
       
    <div className="time-entry-inline">
       <div className="item small">
           <span className="label">Task</span>
            <span className="value" style={{width:'320px'}}>{entry.task?.issueTitle || '-'}</span>
        </div>
        <div className="item small">
         <span className="label">Project</span>
         <span className="badge project-badge">{entry.task?.projectName || '-'}</span>
        </div>
      <div className="item small">
        <span className="label">Hours Spent</span>
        <span className="value">{statusItem.hoursLogged ?? 0}h</span>
      </div>

      <div className="item small">
        <span className="label">Hours Billable</span>
        <span className="value">{statusItem.hoursBillable ?? 0}h</span>
      </div>

      <div className="item">
        <span className="label">Duty Type</span>
        <span className={`badge ${dutyClass}`}>{dutyShort}</span>
      </div>

      <div className="item">
        <span className="label">Status</span>
        <span className={`badge ${statusClass}`}>{statusVal}</span>
      </div>

     <div
  className="description"
  style={{
    display: "flex",
    gap: "10px",
    alignItems: "flex-start",
  }}
>
  {/* Description */}
  <div style={{ flex: 1 }}>
    <span className="label">Description</span>
    <span className="desc" style={{ whiteSpace: "pre-wrap" }}>
      {statusItem.description || "-"}
    </span>
  </div>

  {/* 🔴 Reject Reason (Day View) */}
  {statusItem.approvedStatus === false && statusItem.reason && (
    <div
      style={{
        flex: 1,
        padding: "6px 10px",
        background: "#FEE2E2",
        color: "#991B1B",
        borderLeft: "4px solid #EF4444",
        borderRadius: "6px",
        fontSize: "13px",
        whiteSpace: "pre-wrap",
      }}
    >
      <strong>Reject Reason:</strong> {statusItem.reason}
    </div>
  )}
</div>

    </div>
  </div>
);

      })}
    </div>
  ))}
</div>


                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })()
          ) : (
            <div style={{ whiteSpace: "normal", wordBreak: "break-word", overflowWrap: "break-word" }}>
              <ListGroup className="task-list " padding="0px" style={{ margin: "0px", padding: "0px", width: "100%", height: "100%", overflowY: "auto" }}>
                {empTask.length > 0 ? (
                 empTask.filter(tasks => tasks.leaveStatus !== true)
                .map((tasks, i) => (

                  tasks.employeeTimeSheetId !== 0 ? (<ListGroupItem
                    className="custom-task-item"
                    key={i}
                    style={i === activeTask ? active : null}
                  >
                    <div className="task-container " style={{ margin: '0px', padding: '0px', gap: '10px' }}>

                      {loginUser?.RoleName !== "Admin" &&
                        <span
                          className="task-check"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!tasks.leaveStatus) {
                              // toggle local expansion state for this row
                              setExpandedRows(prev => ({ ...prev, [i]: !prev[i] }));
                              // keep parent informed so selectedTask still updates
                              handleOnclickSelectedTask(tasks, i);
                            }
                          }}
                          style={{
                            cursor: tasks.leaveStatus ? 'not-allowed' : 'pointer',
                            opacity: tasks.leaveStatus ? 0.4 : 1
                          }}
                        >
                          <i className={`fas ${expandedRows[i] ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                        </span>
                      }

                      <span className="task-check">
                        {tasks.timeSheetStatus == 3 ? (<i className="fas fa-check  project-task-icon" style={{ color: 'green' }}></i>) : <i className="fas fa-check  project-task-icon"></i>}

                      </span>
                      <div
                       onClick={() => {
    if (!tasks.leaveStatus) {
      setExpandedRows(prev => ({ ...prev, [i]: !prev[i] }));
      handleOnclickSelectedTask(tasks, i);
    }
  }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        padding: "10px 15px",
                        background: "#fff",
                        borderRadius: "5px",
cursor: "pointer"  
                      }}>
                        <div style={{ flex: 1.5, wordBreak: "break-word" }}>
                          <span className="task-label">{tasks.leaveStatus === false ? tasks.issueTitle : (tasks.leaveType === 1 ? ("Half Day Leave on " + moment(tasks.workDate).format("DD-MM-YYYY")) : (tasks.leaveType === 2 ? "Full Day Leave on " + moment(tasks.workDate).format("DD-MM-YYYY") : "Attendance Override on " + moment(tasks.workDate).format("DD-MM-YYYY")))}</span>
                        </div>
                        <div style={{
                          flex: 1.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: "10px",
                          flexWrap: "nowrap",
                          minWidth: 240,
                          overflow: 'hidden'
                        }}>
                          <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'nowrap', gap: '5px', whiteSpace: 'nowrap' }}>

                            {tasks.leaveStatus === false && (<span className="ovalCircle" title="Project Name">{tasks.projectName}</span>)}

                            {tasks.leaveStatus === false && (
                              <span className="badge badge-info" style={{ background: '#dff7f0', color: '#0b7a56', padding: '6px 10px', borderRadius: 12 }} title="Time entries">{(tasks.employeeTimeSheetStatuses || []).length} Time Entr{(tasks.employeeTimeSheetStatuses || []).length>1? 'ies':'y'}</span>
                            )}

                            {/* circular id bubble on the right */}
                           

                            {tasks.leaveStatus === false && (

                              <span className="badge badge-info" style={{ background: '#dff7f0', color: '#0b7a56', padding: '6px 10px', borderRadius: 12 }} title="Total hours spent">Total Hours : {tasks.totalHoursLogged}h</span>
                              )}

                            {loginUser?.RoleName !== "Admin" && tasks.leaveStatus === false &&
                              (<span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  try {
                                    // make sure parent knows which task is selected first
                                    handleOnclickSelectedTask && handleOnclickSelectedTask(tasks, i);
                                  } catch (err) {
                                    // ignore
                                  }
                                  // then open edit modal, passing the task object so parent can use it to pre-populate
                                  handleAddEditTaskForm && handleAddEditTaskForm("edit", tasks);
                                }}
                                className="action-circle large delete-btn"
                                title="Edit"
                                style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "#000000ff",
          fontSize: "16px",
          padding: 0,
        }}
                              >
                                <i className="fa fa-edit"></i>
                              </span>)}
                            

                            {tasks.workDate !== null && tasks.leaveStatus != true ? (((moment(tasks.workDate).format("YYYY-MM-DD") > moment(firstDay).format("YYYY-MM-DD"))) || (allowedDatesN.includes(moment(tasks.workDate).format('YYYY-MM-DD'))) ?
                              (<span
                                className="action-circle large delete-btn"
                                title="Delete Task"
                                onClick={() => DelTask(tasks.employeeTimeSheetId, tasks)}

                              // disabled={tasks.workDate !== null? ((moment(tasks.workDate).format("YYYY-MM-DD") > moment(firstDay).format("YYYY-MM-DD") && moment(tasks.workDate).format("YYYY-MM-DD") < moment(lastDay).format("YYYY-MM-DD") ) ? false :true) : true}
                              >
                                <i className="fa fa-trash"></i>
                              </span>) : (null

                              )) : (null

                            )
                            }
                          </span>
                        </div>
                      </div>
                    </div>

                    {(expandedRows[i] || expandedIndex === i) && tasks?.leaveStatus !== true && (
              <div className="time-log-container mt-3">
  <h6 className="fw-semibold text-dark mb-3">🕒 Time Logging Details</h6>

  {(tasks?.employeeTimeSheetStatuses || []).length > 0 ? (
    tasks.employeeTimeSheetStatuses.map((entry, index) => {
      const status =
        entry.statusName || entry.timeSheetStatus || entry.status || "";
      const dutyType = entry.dutyType?.split(" ")
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase() || "-";

      const statusText =
        status === 3
          ? "Completed"
          : status === 2
          ? "In Progress"
          : status === 1
          ? "New"
          : status;

      const statusStyle =
        statusText === "Completed"
          ? "status-badge completed"
          : statusText === "In Progress"
          ? "status-badge progress"
          : "status-badge pending";

      const dutyStyle =
        dutyType === "WFH" || dutyType === "Work From Home"
          ? "duty-badge wfh"
          : dutyType === "WFO" || dutyType === "Work From Office"
          ? "duty-badge wfo"
          : "duty-badge ac";

      return (
        <div key={index} className="time-log-card">
          <div className="time-log-grid align-items-center">
            <div>
              <span className="label">Date</span>
              <span className="value">
                {moment(entry.statusDate).format("MMM DD, YYYY")}
              </span>
            </div>

            <div>
              <span className="label">Hours Spent</span>
              <span className="value">{entry.hoursLogged ?? "0"}h</span>
            </div>

            <div>
              <span className="label">Hours Billable</span>
              <span className="value">{entry.hoursBillable ?? "0"}h</span>
            </div>

            <div>
              <span className="label">Duty Type</span>
              <span className={dutyStyle}>{dutyType}</span>
            </div>

            <div>
              <span className="label">Status</span>
              <span className={statusStyle}>{statusText}</span>
            </div>

     <div className="description" style={{ display: "flex", gap: "12px" }}>
  <div style={{ flex: 1 }}>
    <span className="label">Description</span>
    <span className="desc" style={{ whiteSpace: "pre-wrap" }}>
      {entry.description || "-"}
    </span>
  </div>

  {entry.approvedStatus === false && entry.reason && (
    <div
      style={{
        flex: 1,
        padding: "6px 10px",
        background: "#FEE2E2",
        color: "#991B1B",
        borderLeft: "4px solid #EF4444",
        borderRadius: "6px",
        fontSize: "13px",
        whiteSpace: "pre-wrap",
        alignSelf: "flex-start",
      }}
    >
      <strong>Reject Reason:</strong> {entry.reason}
    </div>
  )}
</div>

          </div>
        </div>
      );
    })
  ) : (
    <div className="text-center text-muted py-3">No time entries available</div>
  )}
</div>

)}


                  </ListGroupItem>) : (null)

                ))) : (<span className="task-label">No task added</span>)}
              </ListGroup>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
);

export default ListTask;
